"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIXATION_METHOD_LABELS = exports.FIXATION_METHODS = void 0;
// Fixation-method codes for Formula/Index-priced tickets (Prisma
// `fixation_method_enum` identifiers). Renaming a code is a breaking change;
// labels are display-only.
exports.FIXATION_METHODS = ['day', 'day_avg', 'Month_avg', 'Custom'];
exports.FIXATION_METHOD_LABELS = {
    day: '1-day',
    day_avg: '5-day average',
    Month_avg: 'Monthly average',
    Custom: 'Custom',
};
//# sourceMappingURL=fixation-method.js.map